import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  query,
  collection,
  where,
  limit,
  orderBy,
  startAfter,
  doc,
  getDocs,
  getDoc,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDoxj6L2rNBHJv-86Z9lxX_lVXHveBUqU8',
  authDomain: 'blaurvis.firebaseapp.com',
  projectId: 'blaurvis',
  storageBucket: 'blaurvis.firebasestorage.app',
  messagingSenderId: '560334304770',
  appId: '1:560334304770:web:82485f57cc106b9192991b'
};

export const app = initializeApp(firebaseConfig);
export const database = getFirestore(app);

export const find = (
  type,
  callback,
  error,
  sort = { field: 'date', order: 'desc' },
  id,
  subtype,
  queries,
  size = 100,
  offsetDoc
) => {
  let q = query(
    collection(database, type),
    orderBy(sort.field, sort.order),
    limit(size)
  );

  if (id && subtype) {
    q = query(
      collection(database, type, id, subtype),
      orderBy(sort.field, sort.order),
      limit(size)
    );
  }

  if (queries && queries.length) {
    for (let i = 0; i < queries.length; i++) {
      const field = queries[i].field;
      const operator = queries[i].operator;
      const value = queries[i].value;
      q = query(q, where(field, operator, value));
    }
  }

  if (offsetDoc) {
    q = query(q, startAfter(offsetDoc));
  }

  getDocs(q)
    .then((response) => {
      if (callback)
        callback(
          response.docs.map((doc) => {
            const docData = doc.data();
            docData.id = doc.id;
            docData.snapshot = doc;
            return docData;
          })
        );
    })
    .catch((err) => {
      console.error(
        'Error query records: ',
        type,
        queries,
        err.code,
        err.message
      );
      if (error) error(err);
    });
};

export const fetch = (id, type, callback, error) => {
  const ref = doc(database, type, id);
  getDoc(ref)
    .then((record) => {
      if (record.exists()) {
        const data = record.data();
        data.id = id;
        if (callback) callback(data);
      } else {
        console.warn('No such doc: ', type, id);
        if (callback) callback({});
      }
    })
    .catch((err) => {
      console.error('Error fetching record: ', type, id, err.code, err.message);
      if (error) error(err);
    });
};

export const add = (type, data, callback, error, id, subtype) => {
  let ref = collection(database, type);
  if (id && subtype) {
    ref = collection(database, type, id, subtype);
  }
  addDoc(ref, data)
    .then(callback)
    .catch((err) => {
      console.error('Error creating record: ', type, id, err.code, err.message);
      if (error) error(err);
    });
};

export const set = (id, type, data, callback, error) => {
  let ref = doc(database, type, id);
  setDoc(ref, data)
    .then(callback)
    .catch((err) => {
      console.error('Error creating record: ', type, id, err.code, err.message);
      if (error) error(err);
    });
};

export const update = (id, type, data, callback, error) => {
  const ref = doc(database, type, id);
  updateDoc(ref, data)
    .then(callback)
    .catch((err) => {
      console.error('Error updating record: ', type, id, err.code, err.message);
      if (error) error(err);
    });
};

export const deleteRecord = (id, type, callback, error) => {
  const ref = doc(database, type, id);
  deleteDoc(ref)
    .then(callback)
    .catch((err) => {
      console.error('Error deleting record: ', type, id, err.code, err.message);
      if (error) error(err);
    });
};

export const getRegistry = (callback, error, sort) => {
  find('registry', callback, error, sort);
};

export const getRegistryItem = (id, callback, error) => {
  fetch(id, 'registry', callback, error);
};

export const getTransactions = (id, callback, error) => {
  find(
    'registry',
    callback,
    error,
    { field: 'date', order: 'desc' },
    id,
    'transactions'
  );
};

export const buyRegistryItem = (id, name, amount, callback, error) => {
  add(
    'registry',
    {
      name: name,
      amount: amount,
      date: new Date()
    },
    callback,
    error,
    id,
    'transactions'
  );
};

export const rsvp = (id, email, attending, message, callback, error) => {
  const date = new Date();
  const guest = { email, attending, message, date };
  update(id, 'guests', guest, callback, error);
};

export const getStatus = (id, callback, error) => {
  fetch(id, 'guests', callback, error);
};

export const log = (guest, path, callback, error) => {
  add('log', { guest, path, date: new Date() }, callback, error);
};

export const signIn = (name, callback, error) => {
  const formattedName = _format(name);
  find(
    'guests',
    callback,
    error,
    { field: 'date', order: 'desc' },
    undefined,
    undefined,
    [{ field: 'users', operator: 'array-contains', value: formattedName }]
  );
};

const _format = (name) => {
  if (name) return name.toLowerCase().replace(' ', '');
  return '';
};
